import { Pipe, PipeTransform } from '@angular/core';
/**
 *  @class ManglePipe
 *  @desc Use this pipe to obfuscate sensitive data on screen. Takes a string
 *    and replaces all but the first and last X letters by a specified symbol.
 *  @param {string} value the value to mangle. has to be a string.
 *  @param {number} clear how many letters at the beginning and end of the string shall be kept unobfuscated. dafaults to 4
 *  @param {string} replaceWith the symbol used to obfuscate the string. default is 'X'
 *
 *  @return {string} obfuscated string if input value was a string, else input value without changes.
 *
 *  @example
 *    {{ 'obfuscate' | mangle:2:'*' }} // output: ob*****te
 */
@Pipe({
    name: 'mangle',
    standalone: true,
})
export class ManglePipe implements PipeTransform {
    public transform(value: string, clear: number = 4, replaceWith: string = 'X'): string {
        if (value.length <= clear * 2) {
            return value;
        }
        const mangledValue: string =
            value.slice(0, clear) + replaceWith.repeat(value.length - 2 * clear) + value.slice(-clear);
        return mangledValue;
    }
}
